import type { SimulationExpression } from '../../simulation.types'
import { parseTaskOutputReference } from '../parseTaskOutputReference'
import type { UnresolvedDependency } from './dependencyCollection.types'

/**
 * The tasks named directly by a path's switches. A `${workflow.input.*}` value
 * is handed to us by whoever starts the workflow, so there's nothing to fetch
 * for it.
 */
export const getExpressionDependencies = (
  expressions: SimulationExpression[]
): UnresolvedDependency[] =>
  expressions.flatMap(expression =>
    Object.entries(expression.switchInputParameters).reduce<
      UnresolvedDependency[]
    >((acc, [semanticType, value]) => {
      const reference = parseTaskOutputReference(value)

      return reference.kind === 'task'
        ? [
            ...acc,
            {
              taskReferenceName: reference.taskReferenceName,
              semanticTypes: [semanticType]
            }
          ]
        : acc
    }, [])
  )
